import _ from 'lodash';
import { createReducer } from '../../../../common/reduxHelpers';
import * as types from './actionTypes';
import * as selectors from './selectors';

export const emptyOrder = {
     id:0
}
export const initialState = {
    ordersList: [],
    activeOrder: emptyOrder,
    previousOrder: emptyOrder,
    isLoading: true,
    selectedTabName: "Active"
};

const reducer = createReducer(initialState, {
    [types.FETCH_SHIPPING_ORDERS_SUCCESS](state, action) {
        let selectedActiveOrder = selectors.getActiveShippingOrdersList([...action.response]);
        let selectedPreviousOrder = selectors.getPreviousShippingOrdersList([...action.response]);         
        let defaultSelectedTabName = (selectedPreviousOrder.length > 0 && selectedActiveOrder.length === 0) ? "Previous" : "Active";
        return _.assign({}, state, {
            ordersList: [...action.response],
            activeOrder: selectedActiveOrder[0] === undefined ? emptyOrder : selectedActiveOrder[0],
            previousOrder: selectedPreviousOrder[0]=== undefined ? emptyOrder : selectedPreviousOrder[0],
            selectedTabName: defaultSelectedTabName,
            isLoading: false,
        });
    },

    [types.FETCH_SHIPPING_ORDERS_REQUEST](state, action) {
        return _.assign({}, state, {
            isLoading: true,
            activeOrder: emptyOrder,
            previousOrder: emptyOrder,  
        });
    },

    [types.FETCH_SHIPPING_ORDERS_FAILURE](state, action) {
        return _.assign({}, state, {
            ordersList: [],
            activeOrder: emptyOrder, 
            previousOrder: emptyOrder,
            isLoading: false,
        });
    },
    [types.SET_ACTIVE_SHIPPING_ORDER](state, action) {
        return _.assign({}, state, {
            activeOrder: _.find(state.ordersList, order => order.id === action.orderId),                        
        });
    },
    [types.SET_PREVIOUS_SHIPPING_ORDER](state, action) {
        return _.assign({}, state, {
           previousOrder : _.find(state.ordersList, order => order.id === action.orderId),                        
        });
    },
    [types.SET_ACTIVE_TAB](state, action) {
        return _.assign({}, state, {            
            selectedTabName: action.selectedTabName
        });
    }
});
export default reducer;